import Pagination from "react-js-pagination";
import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { open, close } from "../redux/popupSlice";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";

import Popup01 from "../pages/popup/Popup01"
import PopupPlusMember from "../pages/popup/PopupPlusMember"

export default function PaginationAdminList(props) {
    const {
        coupon
    } = props

    const dispatch = useDispatch();
    const lang = useSelector(state => state.langReducer.lang);

    const dataList = coupon || [1, 2, 3, 4, 5, 6, 7, 8, 9];

    const [page, setPage] = useState(1);
    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };  

    const itemsPerPage = 8;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const Items = dataList.slice(indexOfFirstItem, indexOfLastItem);

    const MeberSetFunc = () => {
        dispatch(open({
            component: 
                <Popup01
                    max_width={'300px'}
                    text1={lang === 0 ? '관리자를 삭제하시겠습니까?' : 'Do you want to remove the administrator?'}
                    buttonCancel={'닫기'}
                    button={'삭제'}
                />
        }));
    }

    return (
        <div className="PaginationContent">
            <div className="my_coupon_list_box admin_list">
                <div className="list_title">
                    <p className="email">{lang === 0 ? '이메일 주소' : 'Email'}</p>
                    <p className="name">{lang === 0 ? '이름' : 'Name'}</p>
                    <p></p>
                </div>

                {dataList ?
                    <>
                        {Items.map((x, i) => (
                            <div key={i} className={`my_coupon_info`}>
                                <p className="email">aiffasf@naver.com</p>
                                <p className="name">{lang === 0 ? '이름입니다' : 'This is the name.'}</p>
                                <p className="member_set">
                                    <span
                                        onClick={() => {
                                            MeberSetFunc()
                                        }}
                                    >
                                        {lang === 0 ? '삭제' : 'Delete'}
                                    </span>
                                </p>
                            </div>
                        ))}
                    </>
                    :
                    <p className="not_coupon">{lang === 0 ? '결제 내역이 없습니다.' : 'There is no payment history.'}</p>
                }                
                
            </div>

            <Pagination
                className="my-pagination"
                // 현재 보고있는 페이지
                activePage={page}
                // 한페이지에 출력할 아이템수
                itemsCountPerPage={8}
                // 총 아이템수
                totalItemsCount={dataList.length || 1}
                // 표시할 페이지수
                pageRangeDisplayed={10}
                // 함수
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default}/>}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default}/>}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default}/>}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default}/>}
            ></Pagination>
        </div>
    )
}